// extracted by mini-css-extract-plugin
export default {"lqip":"PlaceholderGradient-module__lqip_r02Dk"};